import { isTravelTypeWithHousing } from '@repo/utils'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { useTravelTypeContext } from '../../contexts'
import { CurrencyEnum } from '../../../lib/graphql'
import { decimalPrice } from '../../../utils'

export const ClientProposalPriceAwaitingConfirmation = () => {
  const { travelType } = useTravelTypeContext()

  return (
    <div className='flex w-full justify-end'>
      <span className='text-xl text-grey-700'>
        <FormattedMessage
          id='ui.ClientProposalPriceAwaitingConfirmation.priceAwaitingConfirmation'
          defaultMessage='Prix à confirmer par {hostOrProvider}'
          values={{
            hostOrProvider: isTravelTypeWithHousing(travelType) ? (
              <FormattedMessage
                id='ui.ClientProposalPriceAwaitingConfirmation.priceAwaitingConfirmation.host'
                defaultMessage="l'hôte"
              />
            ) : (
              <FormattedMessage
                id='ui.ClientProposalPriceAwaitingConfirmation.priceAwaitingConfirmation.provider'
                defaultMessage='le prestataire'
              />
            ),
          }}
        />
      </span>
    </div>
  )
}

export const ClientProposalPrice = ({
  priceWithoutVat,
  adults,
  isEstimatedPrice,
  currency,
}: {
  priceWithoutVat: number
  adults: number
  isEstimatedPrice: boolean
  currency: CurrencyEnum
}) => {
  const pricePerPersonWithoutVat = Math.round(priceWithoutVat / adults)

  return (
    <div className='flex justify-end gap-2'>
      <div className='flex flex-col items-end gap-1'>
        <div className='flex items-center'>
          {isEstimatedPrice && (
            <span className='mr-1 text-xl text-grey-700'>
              <FormattedMessage
                id='ui.ClientProposalPrice.fromPrice'
                defaultMessage='À partir de'
              />
            </span>
          )}
          <span className='mr-1 text-xl font-bold'>
            {decimalPrice(priceWithoutVat, { currency })}
          </span>
          <div className='self-end'>
            <span className='text-xs'>
              <FormattedMessage
                id='ui.ClientProposalPrice.vat'
                defaultMessage='HT'
              />
            </span>
          </div>
        </div>
        <span className='text-sm text-grey-700'>
          <span className='font-semibold'>
            {decimalPrice(pricePerPersonWithoutVat, { currency })}
          </span>{' '}
          <FormattedMessage
            id='ui.ClientProposalPrice.pricePerPersWithoutVat'
            defaultMessage='HT /pers'
          />
        </span>
      </div>
    </div>
  )
}

export const ClientProposalPriceWithDiscount = ({
  priceWithoutVat,
  discountPriceWithoutVat,
  adults,
  isEstimatedPrice,
  currency,
}: {
  priceWithoutVat: number
  discountPriceWithoutVat: number
  adults: number
  isEstimatedPrice: boolean
  currency: CurrencyEnum
}) => {
  const pricePerPersonWithoutVat = Math.round(priceWithoutVat / adults)
  const pricePerPersonWithDiscountWithoutVat = Math.round(
    discountPriceWithoutVat / adults,
  )

  return (
    <div className='flex justify-end gap-3'>
      <div className='flex flex-col items-end justify-end gap-1'>
        <div className='flex items-center gap-2 text-sm'>
          {isEstimatedPrice && (
            <span className='text-xl text-grey-700'>
              <FormattedMessage
                id='ui.ClientProposalPrice.fromPrice'
                defaultMessage='À partir de'
              />
            </span>
          )}
          <div className='mt-1 flex items-center'>
            <span className='mr-1 font-bold line-through decoration-black'>
              {decimalPrice(priceWithoutVat, { currency })}
            </span>
            <div className='self-end'>
              <span className='line-through decoration-black'>
                <FormattedMessage
                  id='ui.ClientProposalPriceWithDiscount.vat'
                  defaultMessage='HT'
                />
              </span>
            </div>
          </div>
        </div>
        <span className='text-sm text-grey-700 line-through decoration-black'>
          <span className='font-semibold'>
            {decimalPrice(pricePerPersonWithoutVat, { currency })}
          </span>{' '}
          <FormattedMessage
            id='ui.ClientProposalPriceWithDiscount.pricePerPersWithoutVat'
            defaultMessage='HT /pers'
          />
        </span>
      </div>
      <div className='flex flex-col items-end gap-1 text-green-500'>
        <div className='flex items-center'>
          <span className='mr-1 text-xl font-bold'>
            {decimalPrice(discountPriceWithoutVat, { currency })}
          </span>
          <div className='self-end'>
            <span className='text-xs'>
              <FormattedMessage
                id='ui.ClientProposalPriceWithDiscount.vat'
                defaultMessage='HT'
              />
            </span>
          </div>
        </div>
        <span className='text-sm'>
          <span className='font-semibold'>
            {decimalPrice(pricePerPersonWithDiscountWithoutVat, { currency })}
          </span>{' '}
          <FormattedMessage
            id='ui.ClientProposalPriceWithDiscount.pricePerPersWithoutVat'
            defaultMessage='HT /pers'
          />
        </span>
      </div>
    </div>
  )
}
